//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    variant: {
      type: String,
      default: 'dark',
      validator (value) {
        return ['light', 'dark'].includes(value)
      }
    },
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: 'form-input-' + Math.random()
    }
  },
  computed: {
    classForInput () {
      let c
      if (this.variant === 'light') {
        c = 'tw-bg-white tw-text-gray-800 tw-placeholder-gray-500 focus:tw-ring-offset-gray-900 focus:tw-ring-white focus:tw-border-white focus:tw-placeholder-gray-400'
      } else {
        c = 'tw-bg-gray-100 tw-text-gray-800 tw-placeholder-gray-600 focus:tw-ring-offset-white focus:tw-ring-gray-200 focus:tw-border-gray-100 focus:tw-placeholder-gray-400'
      }

      if (this.value) {
        c += ' tw-pt-4 tw-pb-1'
      } else {
        c += ' tw-py-2'
      }

      return this.inputClass ? this.inputClass + ' ' + c : c
    }
  },
  methods: {
    focus () {
      this.$refs.input.focus()
    }
  }
}
